module.exports = __webpack_public_path__ + "img/caderno-circle.d9aae638.png";